import { ACT_SLUG, DAT_SLUG, LSAT_SLUG, MCAT_SLUG, SAT_SLUG } from 'my-core/course-utils';
import {
  aboutPath,
  actLandingPath,
  actTutoringLandingPath,
  adminDashboardPath,
  announcementsPath,
  brandAmbassadorDashboardPath,
  careersPath,
  checkoutPath,
  classRepDashboardPath,
  classRepPositionsPath,
  classRepWizardPath,
  contentCreatorDashboardPath,
  contestPath,
  coursesPath,
  datEliteLandingPath,
  datEventsPath,
  datLandingPath,
  datSelfPacedLandingPath,
  datTutoringLandingPath,
  educatorsLandingPath,
  essayWriterLandingPagePath,
  essayWriterPath,
  highSchoolLandingPath,
  instructorDashboardPath,
  invitesPagePath,
  jobApplicantPath,
  livePrepLandingPath,
  lsatEventsPath,
  lsatLandingPath,
  lsatSelfPacedLandingPath,
  lsatTutoringLandingPath,
  marketingRepDashboardPath,
  mcatEventsPath,
  mcatExamDates,
  mcatFreeResourcesPath,
  mcatRepDashboardPath,
  medSchoolAdmissionsLandingPath,
  medSchoolCalculatorPath,
  onDemandLandingPath,
  parentsLandingPath,
  partnershipsPath,
  preMedPlusLandingPath,
  preMedTutoringLandingPath,
  pricingPath,
  satLandingPath,
  satTutoringLandingPath,
  scholarshipsPath,
  searchPagePath,
  studentActDashboardPath,
  studentDatDashboardPath,
  studentLsatDashboardPath,
  studentMcatDashboardPath,
  studentOnboardingPath,
  studentSatDashboardPath,
  studentSignupPath,
  subscriptionLandingPath,
  teacherDashboardPath,
  tokensDashboardPath,
  tutoringDashboardPath,
  tutoringLandingPath,
  universityLandingPath,
} from 'my-core/routes';

export const NO_APPBAR_ROUTES = [
  /\/online-courses\/\d+\/print/,
  /\/study-rooms/,
  studentSignupPath(),
  studentOnboardingPath(),
  checkoutPath(),
  classRepWizardPath(''),
];

export const PRODUCT_PAGES_CONFIG = [
  { product: MCAT_SLUG, regex: new RegExp(`\\b${MCAT_SLUG}\\b`), loginRedirect: studentMcatDashboardPath() },
  { product: LSAT_SLUG, regex: new RegExp(`\\b${LSAT_SLUG}\\b`), loginRedirect: studentLsatDashboardPath() },
  { product: DAT_SLUG, regex: new RegExp(`\\b${DAT_SLUG}\\b`), loginRedirect: studentDatDashboardPath() },
  { product: SAT_SLUG, regex: new RegExp(`\\b${SAT_SLUG}\\b`), loginRedirect: studentSatDashboardPath() },
  { product: ACT_SLUG, regex: new RegExp(`\\b${ACT_SLUG}\\b`), loginRedirect: studentActDashboardPath() },
];

export const ALT_PATHS = [
  { path: '/', exact: true, type: 'light' },
  { path: '/homepage', type: 'light' },
  { path: aboutPath(), type: 'light' },
  { path: careersPath(), type: 'color' },
  { path: classRepPositionsPath(), type: 'dark' },
  { path: contestPath(), type: 'light' },
  { path: /\/courses\/[^/]+\/booklet/, type: 'light' }, // course booklet page
  { path: /\/courses\/[^/]+/, type: 'dark' },
  { path: coursesPath().pathname, type: 'light' },
  { path: educatorsLandingPath(), type: 'light' },
  { path: highSchoolLandingPath(), type: 'light' },
  { path: invitesPagePath() },
  { path: '/job-positions', type: 'color' },
  { path: livePrepLandingPath(), type: 'color' },
  { path: mcatEventsPath(), exact: true, type: 'dark' },
  { path: mcatExamDates(), type: 'light' },
  { path: mcatFreeResourcesPath(), type: 'dark' },
  { path: medSchoolCalculatorPath(), type: 'color' },
  { path: medSchoolAdmissionsLandingPath(), type: 'dark' },
  { path: lsatLandingPath(), exact: true, type: 'light' },
  { path: lsatEventsPath(), exact: true, type: 'dark' },
  { path: lsatSelfPacedLandingPath(), exact: true, type: 'light' },
  { path: lsatTutoringLandingPath(), exact: true, type: 'dark' },
  { path: preMedPlusLandingPath(), type: 'dark' },
  { path: preMedTutoringLandingPath(), type: 'dark' },
  { path: datLandingPath(), exact: true, type: 'light' },
  { path: datSelfPacedLandingPath(), exact: true, type: 'light' },
  { path: datEliteLandingPath(), exact: true, type: 'light' },
  { path: datTutoringLandingPath(), exact: true, type: 'dark' },
  { path: datEventsPath(), exact: true, type: 'dark' },
  { path: satLandingPath(), exact: true, type: 'dark' },
  { path: satTutoringLandingPath(), exact: true, type: 'dark' },
  { path: actLandingPath(), exact: true, type: 'dark' },
  { path: actTutoringLandingPath(), exact: true, type: 'dark' },
  { path: onDemandLandingPath(), type: 'color' },
  { path: /\/online-courses\/\d+$/, type: 'light' },
  // { path: /\/online-courses\/\d+\/manager/, type: 'color' },
  { path: parentsLandingPath(), type: 'light' },
  { path: /\/partners\// },
  { path: partnershipsPath(), type: 'light' },
  { path: pricingPath(), type: 'light' },
  { path: scholarshipsPath(), exact: true },
  { path: '/schools/', type: 'color' },
  { path: searchPagePath(), type: 'light' },
  { path: subscriptionLandingPath() },
  { path: teacherDashboardPath(), type: 'color' },
  { path: tokensDashboardPath(), type: 'light' },
  { path: tutoringDashboardPath(), type: 'color' },
  { path: tutoringLandingPath(), type: 'medium' },
  { path: '/tutors' },
  { path: universityLandingPath(), type: 'light' },
  { path: '/online-course-activities', type: 'color' },
  { path: /\/textbooks\/[^/]+(\/[^/]+)?$/, type: 'color' },
  { path: /\/textbooks\/.*\/sections\//, type: 'light' },
  { path: essayWriterPath(), exact: true, type: 'color' },
  { path: essayWriterLandingPagePath(), exact: true, type: 'light' },
  { path: '/admin', type: 'light' },
];

const ADMIN_ROUTE = { path: adminDashboardPath(), label: 'Admin' };

export const ROLE_ROUTES = [
  ['marketing_rep', { label: 'Marketing Dashboard', path: marketingRepDashboardPath() }],
  ['class_rep', { label: 'Class Rep Dashboard', path: classRepDashboardPath() }],
  ['mcat_rep', { label: 'MCAT Rep Dashboard', path: mcatRepDashboardPath() }],
  [['class_rep', 'marketing_rep'], { label: 'Announcements', path: announcementsPath() }],
  ['job_applicant', { label: 'Job Application', path: jobApplicantPath() }],
  ['brand_ambassador', { label: 'Brand Ambassador Dashboard', path: brandAmbassadorDashboardPath() }],
  ['admin', { path: instructorDashboardPath(), label: 'Educator Dashboard' }],
  [['admin', 'mcat_sales_rep'], ADMIN_ROUTE],
];

export const VARIANTS = {
  admin: {
    left: [ADMIN_ROUTE],
  },
  // are we still using this role?
  content_creator: {
    left: [{ path: contentCreatorDashboardPath(), label: 'Dashboard' }],
  },
  guest: {},
  instructor: {
    left: [{ path: instructorDashboardPath(), label: 'Dashboard' }],
  },
  student: {},
  tutor: {
    left: [{ path: instructorDashboardPath(), label: 'Dashboard' }],
  },
  teacher: {
    left: [{ path: teacherDashboardPath(), label: 'Dashboard' }],
  },
  manager: {
    left: [ADMIN_ROUTE],
  },
};
